<script lang="ts">
    /**
     * HomePage - 홈페이지 메인 (섹션 오케스트레이터)
     *
     * CSO 문서 v2 기준 8개 섹션 조합
     * - Section 1: 히어로 배너
     * - Section 2: 핵심 차별화 (협동+추격+비교)
     * - Section 3: 주요 기능 소개 (10+3)
     * - Section 4: 신뢰 요소
     * - Section 5: 사용자 가이드 & FAQ
     * - Section 7: 사전등록 CTA
     * - Section 8: 푸터 (LandingFooter에서 처리)
     */
    import JadeyeSubNav from '../components/JadeyeSubNav.svelte';
    import HeroSection from './sections/HeroSection.svelte';
    import DifferentiationSection from './sections/DifferentiationSection.svelte';
    import FeaturesSection from './sections/FeaturesSection.svelte';
    import GuideSection from './sections/GuideSection.svelte';
    // TODO: 사전등록 기능 활성화 시 주석 해제
    // import PreRegisterSection from './sections/PreRegisterSection.svelte';
</script>

<!-- title·description 은 config/seo.php 가 SSOT (LandingApp.applyMeta 참고) -->

<div class="home-page">
    <HeroSection />
    <JadeyeSubNav />
    <DifferentiationSection />
    <FeaturesSection />
    <GuideSection />
    <!-- TODO: 사전등록 기능 활성화 시 주석 해제 -->
    <!-- <PreRegisterSection /> -->
</div>

<style>
    .home-page {
        width: 100%;
    }
</style>
